"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.infiniteLoaderHOC = void 0;
var infiniteLoader_1 = require("./infiniteLoader");
Object.defineProperty(exports, "infiniteLoaderHOC", { enumerable: true, get: function () { return __importDefault(infiniteLoader_1).default; } });
